<template>
    <footer class="footer container"
            v-if="$parent.corporation.theme_marketplace_footer_course"
            :style="{background: `url(${$parent.corporation.theme_marketplace_footer_course}) no-repeat center center`}">
            <div class="bottom"><hr></div>
    </footer>
    <footer v-else class="footer course container">
        <select @change="switchLanguage"
                 v-model="language"
                 v-if="showlanguage">
            <option value="en">English</option>
            <option value="fr">French</option>
            <option value="es">Spanish</option>
        </select>
        <div class="bottom"><hr></div>
    </footer>
</template>

<script>

import API from '@/api/index';
export default {
    name: "CourseFooter",
    data: function(){
        return {
            language : "",
            showlanguage : true
        }
    },
    mounted(){
        this.language = LANGUAGEAPP;
        this.showlanguage = SHOWLANGUAGEAPP;
    },
    methods : {
    	async switchLanguage(){

    		var response = await  API.phpAppEndpoints.changeLanguage({body:{language:this.language}})
    		location.reload();
    	}
    }
}
</script>

<style scoped>

</style>
